// Utils
import * as pointLib from '../../maths/geometry/point';

// Types
import { Point } from '../../maths/geometry/pointTypes';
import { getXPosition, getYPosition } from './elementPropertyUtils';
import { MNElement } from '../elementModelTypes';

export const DEFAULT_CANVAS_ORIGIN = { x: 0, y: 0 };
export const MINIMUM_CANVAS_ORIGIN = -500;
export const MAXIMUM_CANVAS_ORIGIN = 0;

export const MAXIMUM_POSITION_VALUE = 10000;
export const MAXIMUM_CANVAS_OVERFLOW_INCREMENT = 100;

export const getRenderedCanvasPositionGridUnits = (
    elementPosition: Point,
    canvasOrigin: Point = DEFAULT_CANVAS_ORIGIN,
): Point =>
    // @ts-ignore - TypeScript doesn't handle currying well
    pointLib.difference(canvasOrigin, elementPosition);

export const getRenderedCanvasPositionPx = (elementPosition: Point, canvasOrigin: Point, gridSize: number): Point =>
    // @ts-ignore - TypeScript doesn't handle currying well
    pointLib.scale(gridSize, getRenderedCanvasPositionGridUnits(elementPosition, canvasOrigin));

// Lists of elements
export const getElementsTopLeftPositionGridUnits = (elements: MNElement[]): Point =>
    elements.reduce(
        (acc, el) => {
            const x = getXPosition(el);
            const y = getYPosition(el);

            if (x < acc.x) {
                acc.x = x;
            }

            if (y < acc.y) {
                acc.y = y;
            }

            return acc;
        },
        { x: Infinity, y: Infinity },
    );
